<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a>Schedules</a></li>
        <li class="breadcrumb-item active" aria-current="page">Create New Schedules</li>
      </ol>
    </div>
    <div class="sub-navbar" v-show="isScheduleView">
      <div class="sub-left">
        <div class="sub-left-inlft">
          <ul class="left-links over-drop">
            <li><span href="#" class="btn sched-btn ">Scheduling Period</span></li>
            <li>
              <div class="dropdown ">
                <div class="input-wrapper new-calender">
                  <div class="  position-relative" >
                    <a class="calendar-opener" @click.prevent="showCalendar = ! showCalendar">
                      <date-picker v-model="selectedDate"  :lang="{formatLocale: {firstDayOfWeek: 1, },}" type="date" range placeholder="Select date range"
                                  value-type="format" format="YYYY-MM-DD" v-on:change="selection($event)"></date-picker>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="left-links over-drop">
            <li><span href="#" class="btn sched-btn ">Scheduling Name</span></li>
<!--            <li v-if="schedule_name">-->
<!--              <a href="javascript:void(0)" class="edit-icon flex-shrink-0 pl-2 mr-20" v-show="isScheduleName==false"-->
<!--                title="Click here to change name" @click="isScheduleNameFun">{{ schedule_name }}</a>-->
<!--              <input type="text" v-show="isScheduleName" v-model="schedule_name" class="form-control"-->
<!--                    placeholder="Enter scheduling name">-->
<!--            </li>-->
            <li >
<!--              <input type="text" v-model="schedule_name" class="form-control" placeholder="Enter scheduling name">
              <div class="input-group-append">
                <button  class="btn btn-info" @click="scheduleNameSaveBtnClick(roster_schedule_id)" type="button">Save</button>

              </div>-->
              <div class="custom-input-group">

                <div class="input-group">
                  <input type="text" class="form-control text-capitalize" placeholder="Enter scheduling name" v-model="schedule_name">
                  <div class="input-group-append ml-5" v-if="roster_schedule_id">
                    <button  class="btn btn-info" @click="scheduleNameSaveBtnClick(roster_schedule_id)" type="button">Save</button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="sub-left-inrgt">
<!--          job role filter component-->
          <job-roles-filter :jobTypes="jobTypes" @selectedShift="filterFunction"></job-roles-filter>
        </div>
      </div>
      <div class="sub-right">
        <ul class="right-links">
          <li>
            <button
              type="button"
              class="btn btn-primary"
              @click="showEmpCreateModal"
            ><i class="ico ico-user"></i>Invite employee</button>

          </li>
          <li>
            <a href="#" class="btn btn-primary" data-target="#setup-rules" data-toggle="modal"><span
            class="ico ico-setting"></span> rules</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="main-box two-column">
      <div class="left-side">

        <div class="schedules-list">
          <ul class="schedules-btn">
            <li>
              <button @click="scheduleBtnFun" class="btn btn-primary  btn-sm" :class="{'active-btn':selected == 1}">
                schedules
              </button>
            </li>
            <li>
<!--              <button to="/template" class="btn btn-gray  btn-sm" @click="templateBtnFun"-->
              <button to="/template" class="btn btn-gray  btn-sm"
                      :class="{'active-btn':selected == 2}">Template
              </button>
            </li>
            <li>
              <div class="nav-selectdrop" v-show="isScheduleView">
                <copy-template-schedule :previousSchedule="previousSchedule"
                                        @selectedRosterScheduleId="copyPreviousScheduleShifts"></copy-template-schedule>
              </div>
            </li>
          </ul>
          <button class="btn btn-outline-primary btn-sm" v-show="isPublished" :disabled="isPublishBtnDisable === true"  data-toggle="modal"
             data-target="#publishModel"><i class="ico ico-upload-file"></i>Publish Shifts</button>
        </div>

        <div class="start-week">
          <h5>Week From {{ startWeek | moment("MMM D, YYYY") }}</h5>
          <div class="week-btn">
            <button @click="removeAllShiftFunction" v-show="isScheduleView" class="btn btn-gray ">Remove All</button>
          </div>
        </div>
        <div v-show="isScheduleView" class="week-table table-responsive-xxl mb-40 " v-bind:class="{ 'filter-active-cus' : filterActiveCus == true}"  v-for="week in byWeekly">
          <table class="table " style="position: relative">
            <span class="spinnerCustom">
              <clip-loader :loading="loadingSpinMain" :size="sizeMain" :color="spinnerColor"></clip-loader>
            </span>
            <thead class="thead">
            <tr>
              <th v-for="day in weeksDatesByWeek[week]" :key="day" :data-day="day" v-if="day>=startWeek && day<=endWeek" >
<!--              <th v-for="day in weeksDatesByWeek[week]" :key="day" :data-day="day" >-->
<!--                {{day}} - {{endWeek}}-->

                <a class="btn btn-dark-gary btn-sm active" style="background: #fd4f50" v-if="day===currentDate">Today,{{
                    day
                      | moment(' D MMM')
                  }}
                  <i @click="copySchedulesByDateFunction(day)" v-show="isCopyByDate==false"
                     class="ico-Copy icoCopyByDate" title="Copy schedules by date"></i>
                  <!-- <i @click="pasteSchedulesByDateFunction(day)" v-show="isCopyByDate==true" class="fas fa-paste icoCopyByDate" title="Paste schedules by date"></i>-->
                </a>
                <a class="btn btn-dark-gary btn-sm btn-hold" v-else>
                  <i @click="deleteSchedulesByDateFunction(day)" v-show="isCopyByDate==false"
                     class="ico-delete icoCopyByDate" title="Delete schedules by date"></i>
                  {{ day | moment('ddd, D MMM') }}
                  <i @click="copySchedulesByDateFunction(day)" v-show="isCopyByDate==false"
                     class="ico-Copy icoCopyByDate" title="Copy schedules by date"></i>
                  <!-- <i @click="pasteSchedulesByDateFunction(day)" v-show="isCopyByDate==true" class="fas fa-paste icoCopyByDate" title="Paste schedules by date"></i>-->
                </a>

              </th>
              <th v-else></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="schedule-td" v-for="(day,keyIndex) in weeksDatesByWeek[week]" v-if="day>=startWeek && day<=endWeek" :keyIndex="day"
                  :class="day===currentDate?' activeToday':''">

                <div class="inner-td-wrp">

                  <div class="copy-days" v-show="isCopyByDate==true">
                    <div class="text-wrap" @click="pasteSchedulesByDateFunction(day)">
                      <h6>Paste this day</h6>
                      <a href="javascript:void(0)">Click here to Paste
                        this day</a>
                    </div>
                  </div>
                  <div>
                    <div class="card-wrapper" v-for="(info,index) in newarray[week+day]" :key="index">

                 <time class="opacity-1" :data-jobroleid="info.job_role_id" v-if="employeeShiftHours[day+info.start_time+info.end_time] " datetime="2021-12-15 15:00" >
                        {{ employeeShiftHours[day+info.start_time+info.end_time].start_time.split(':')[0] + ":" + employeeShiftHours[day+info.start_time+info.end_time].start_time.split(':')[1] }} -
                        {{ employeeShiftHours[day+info.start_time+info.end_time].end_time.split(':')[0] + ":" + employeeShiftHours[day+info.start_time+info.end_time].end_time.split(':')[1] }}
                      </time>
                       <div v-if="employeeShiftHours[day+info.start_time+info.end_time]">
                                          <div class="mini-card-wrp" v-for="(item,keyInt) in  employeeShiftHours[day+info.start_time+info.end_time].shift">
<!--                                            <pre ><code>{{ item.id+item.date  }}</code></pre>-->
                                            <div class="mini-card border-gray" :data-jobroleid="item.job_role_id" :data-highlight="item.id+'-'+item.date"
                                                 v-bind:class="{ 'matchShiftClass' : selectedShift === item.jobRole.id ||
                                                  selectedShift === 'available_'+item.is_shift_available ||
                                                  selectedShift === 'highlightShift_'+item.id+'-'+item.date,
                                                 'matchShiftClassBg':selectedShiftForViolationEmpId==(item.employee)? item.employee.id:'' && selectedShiftForViolationDate==item.date }">
                                              <div class="card-body">
                                                <span class="emp-designation" v-if="item.employee"><i class="ico ico-fill-circle" :style="'color:'+item.jobRole.color"></i>
<!--                                                     <router-link :to="'/employee/profile/'+item.employee.uuid" style="color: black">{{ item.employee.name }}</router-link> </span>-->
                                                     {{ item.employee.name }} </span>
                                                <span class="text-danger text-capitalize emp-designation font-weight-bold pt-10" v-else>
                                                       <i class="ico ico-fill-circle text-danger"></i>open shift</span>
                                                <div class="d-flex justify-content-between">

                                                 <span class="total-tag-sm" v-if="item.employee">
                                                  <span v-if="item.employee.employment_type == 'full-time'">
                                                    {{ currencySymbol }} {{ item.emp_hourly_rate ? item.emp_hourly_rate.toFixed(2) : 0 }} / hr
                                                  </span>
                                                  <span class="total-tag-sm" v-else>
                                                    {{ currencySymbol }} {{ item.employee.hourly_rate }} / hr
                                                  </span>
                                                </span>


                                                 <span class="total-tag-sm" v-if="item.employee">
                                                  <span v-if="item.employee.employment_type == 'full-time'">
                                                    {{currencyAmountFormat(hourlyPriceCalculate(item.emp_hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                                  </span>
                                                  <span class="total-tag-sm" v-else>
                                                    {{currencyAmountFormat(hourlyPriceCalculate(item.employee.hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                                  </span>
                                                  </span>
                                                </div>
                                              </div>
                                              <!--Edit section -->
<!--                                              <pre ><code>{{ info  }}</code></pre>-->
                                              <edit-shift :item="item" :week="week" :day="day" :index="index" :keyInt="keyInt" :jobTypes="jobTypes" :info="info" @updateShift="updateSchedule" @isCopy="singleCopyTestingCode" @isDeleted="deleteSchedule"></edit-shift>
                                            </div>
                                          </div>
                                        </div>
                      <div v-else>
                      </div>
                    </div>
                    <div class="card-wrapper cardWrapperCus" v-show="isCopy==true">
                      <div class="mini-card border-gray " style="padding:10px">
                        <div class="text-wrap" @click="pastScheduleFunction(day)">

                          <h6 class="p-4 text-center">Paste this shift</h6>
                          <button class="btn" >Click here to copy
                            to this shift
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="shift-dropdown shiftDropdownCus">
                      <!--Total Rs 1400/hr-->
                      <div class="total-tag-lg" v-if="newarray[week+day]">
                        <span class="tag-title" v-if="totalCostByDate[week][keyIndex]>0">Total</span>
                        <span class="total-amount"
                              v-if="totalCostByDate[week][keyIndex]>0">{{ currencyAmountFormat(totalCostByDate[week][keyIndex]) }} {{ currencySymbol }}</span>
                      </div>
                      <a class="btn btn-outline-primary btn-sm add-shift-btn-cus" data-toggle="collapse"
                         @click="addShiftBtn"
                         :href="'#shift-dropdown-'+week + keyIndex"
                         role="button" aria-expanded="false" aria-controls="shift-dropdown">
                        Add shift
                      </a>
                      <!-- Add shift -->
                      <div class="shift-dropmenu shift-dropmenu-add collapse" v-show="isModalVisible"
                           :id="'shift-dropdown-' +week+ keyIndex">
                        <add-shift :roster_schedule_id="roster_schedule_id" :week="week" :startWeek="startWeek" :endWeek="endWeek" :day="day" :keyIndex="keyIndex" :jobTypes="jobTypes" @shiftSave="shiftSaveFunc" @shiftSaveMore="addAnotherShiftFun" ></add-shift>
                      </div>
                    </div>
                  </div>


                </div>
              </td>
              <td v-else></td>
            </tr>
            </tbody>
          </table>
        </div>
        <template-view v-show="isTemplateView"></template-view>
      </div>
      <aside class="right-side">
        <div class="card ">
          <div class="card-head">
            <h3>Your Schedule overview</h3>
          </div>
          <div class="card-body">
            <div class="card-detail">
              <span>{{ shiftNeedAssignment }} Shifts Need(s) Assignment</span>
            </div>
            <div class="card-detail">
              <span>{{ hoursAssigned }} hours {{ minutesAssigned }} minutes Assigned</span>
            </div>
            <div class="violation-box">
              <strong class="violation-box-title text-danger"> <span
                v-if="employeeRuleViolation.totalCountRulesViolation>0">{{ employeeRuleViolation.totalCountRulesViolation }}</span> <span v-else>0</span>
                Rules Violation <span class="ico-refresh violation-refresh" style="cursor: pointer" @click="refreshViolation"></span></strong>
              <div class="violation-list-wrp">
                <ul class="violation-list">
                  <!-- <li v-for="item in employeeRuleViolation"><span class="badge badge-light">{{item}}</span> </li> -->
<!--                  <li class="cursor-pointer" v-for="employee in employeeRuleViolation"  @click="highlightEmployee(employee.shiftId,employee.date)">-->
<!--                  <li class="cursor-pointer" v-for="employee in employeeRuleViolation"  @click="highlightEmployeeShift(employee.shiftId,employee.date)">-->
                  <li class="cursor-pointer" v-for="employee in employeeRuleViolation" v-if="employee.employee_shift_violation || employee.employee_maxHoursPerWeek || employee.employee_maxWorkdaysInRow || employee.employee_minHoursPerWeek" >
                    <div class="violation-list-top">
                                            <span class="violation-name text-capitalize">{{employee.name}}</span>
<!--                                            <span class="violation-date">{{employee.date | moment('D-MM-Y')}}</span>-->
                    </div>
                    <ul class="violation-ul">
                      <li v-if="employee.employee_shift_violation" v-for="shiftViolation in employee.employee_shift_violation" @click="highlightEmployee(shiftViolation.shiftId,shiftViolation.date)">
                        <span class="viola-name">Max. hours per day ({{shiftViolation.hours}}Hrs)</span>
                        <br>
                                                <span class="viola-hr">{{shiftViolation.date | moment('D-MM-Y')}}</span>
                      </li>
                      <li v-if="employee.employee_maxHoursPerWeek">
                        <span class="viola-name">{{ employee.employee_maxHoursPerWeek.title }} ({{ employee.employee_maxHoursPerWeek.hours}}Hrs)</span>
<!--                        <span class="viola-hr">05</span>-->
                      </li>
                      <li v-if="employee.employee_maxWorkdaysInRow">
                        <span class="viola-name">{{ employee.employee_maxWorkdaysInRow.title }}({{ employee.employee_maxWorkdaysInRow.total_shifts_in_period}} shifts)</span>
                        <!--                        <span class="viola-hr">05</span>-->
                      </li>
                      <li v-if="employee.employee_minHoursPerWeek">
                        <span class="viola-name">{{ employee.employee_minHoursPerWeek.title }}({{ employee.employee_minHoursPerWeek.hours}}Hrs)</span>
                        <!--                        <span class="viola-hr">05</span>-->
                      </li>

                    </ul>
<!--                    <p>{{ employee.rule }}</p>-->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>


        <div class="card ">
          <div class="card-head">
            <h3>Total Hours per employee</h3>
          </div>
          <div class="card-body">
            <div class="card-detail sub-heading border-bottom-0 pb-0">
              <span>  {{ startWeek | moment("MMM  D") }} - {{ endWeek | moment("MMM  D") }} </span>
              <span>{{ totalHoursPerEmp }}:{{ totalMinutesPerEmp }} Hrs</span>
            </div>
            <div class="card-detail  sub-heading" v-if="totalCost>0">
              <span>  Total Cost </span>
              <span class="text-danger">{{ currencyAmountFormat(totalCost) }} {{ currencySymbol }}</span>
            </div>

            <!--Total Cost Rs 7650-->
            <div class="card-detail ">
              <span>Available shifts </span>
              <span>{{ availableShiftHours }}:{{ availableShiftMinutes }} Hrs</span>
            </div>
            <div class="total-hours-per-emp-cus">
              <div class="px-20">
                <div class="card-detail " v-if="totalHoursPerEmployeeList.length>0"
                     v-for="emp in totalHoursPerEmployeeList">
                  <span class="text-capitalize"><i class="ico ico-double-tick "></i> {{ emp.name }}</span>
                  <span>{{ emp.totalTime }} Hrs</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
    <!--publish model -->
    <div class="modal fade " id="publishModel" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">You are Publishing your Schedule to your Employees
            </h5>
            <p></p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="sticky-check">
              <label class="custom-check-box ">
                <input type="checkbox" name="check01" checked="">
                <span class="radio-check">Send notifications regarding the new schedule to the relevant employee</span>
              </label>
            </div>
            <div class="simple-text">
              <p>When you publish your schedule, your employees will be notified about the new schedule.</p>
            </div>
            <h5 class="modal-title sub-heading" id="publishModelLabel">You are Publishing your Schedule to your
              Employees</h5>
            <ul class="publish-sch">
              <li>See shifts.</li>
              <li>Swap shifts</li>
              <li>Sync shifts with their personal calendar.</li>
              <li>Edit attendance on old shifts.</li>
            </ul>

            <div class="note-message">
              <h5 class="note-head"><i class="ico-check_on"></i> No conflicts found</h5>
            </div>

          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
               aria-label="Close">Cancel</a>
            <button @click="publishScheduleFunction" class="btn btn-outline-primary btn-sm">Approve and Publish</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal setup general -->
    <div class="modal fade" id="setup-rules" tabindex="-1" role="dialog" aria-labelledby="setup-rulesLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <rules-violation @submitRules="submitFormRules" ></rules-violation>
      </div>
    </div>

    <!-- create employee Model -->
    <createEmployeeModal ref="modal"></createEmployeeModal>

    <!--shift when copy paste by date-->
    <div class="modal fade " id="shiftModel"  :class="{'show':isCopyPasteByDate == true}" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">Conflicting shifts by date {{copyByDate}}
            </h5>
            <p></p>
            <button  @click="hideCopyPasteByDateModalBtn" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-scroll employee-benifits">
              <table class="table">
                <thead class="table-head">
                <tr>
                  <th scope="col">Employee</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End Time</th>
                  <th scope="col">Description</th>
                  <th scope="col">Status</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(shift, index) of pasteSchedulesByDateData"
                  :key="index"
                >
                  <td>
                    <span class="text-capitalize">{{ shift.empName }}</span>
                  </td>
                  <td>
                    {{ shift.start_time }}
                  </td>
                  <td>
                    {{ shift.end_time }}
                  </td>

                  <td>
                    {{ shift.title }}
                  </td>
                  <td>
                    {{ shift.status }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    rules violation model-->
    <div
      class="modal fade write-msg-model creat-employee-modal"
      id="cardModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5 class="text-capitalize">Violation</h5>
<!--              <h5 class="text-capitalize">{{ editShiftEmployee.employee.name }}</h5>-->
              <p>{{ editShiftEmployee.date }}</p>
              <p class="">Shift Time  {{ editShiftEmployee.start_time }} - {{ editShiftEmployee.end_time }} </p>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Start Shift</label>
                    <input type="time" class="form-control" v-model="editShiftEmployee.start_time" />
                  </div>
                  <div class="field-col">
                    <label>End Shift</label>
                    <input type="time" class="form-control" v-model="editShiftEmployee.end_time" />
                  </div>
                  <div class="field-col">
                    <label>Note (optional)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="editShiftEmployee.comment"
                    />
                  </div>
                </div>
                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Break Time</label>
                    <div class="nav-selectdrop">
                      <select
                        id="inputState"
                        class="form-control"
                        v-model="editShiftEmployee.break_time"
                      >
                        <option :value="'20'" selected="selected">
                          20 Min
                        </option>
                        <option :value="'30'">30 Min</option>
                        <option :value="'40'">40 Min</option>
                        <option :value="'60'">60 Min</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
            >Cancel</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import router from '../../router/router'
import weeklyDatepicker from "./datepicker";
import templateView from "./template-view";
import rulesViolation from "./rules-violation";
import DatePicker from 'vue2-datepicker'
import createEmployeeModal from "../Employees/createEmployeeModal";
import moment from 'moment'
import axios from "axios";
import copyTemplateSchedule from "./copy-template-schedule";
import jobRolesFilter from "./partials/jobRolesFilter";
import editShift from "./partials/editShift";
import addShift from "./partials/addShift";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Swal from "sweetalert2";
export default {
  name: 'signup',
  components: {
    'weeklyDatepicker': weeklyDatepicker,
    'copyTemplateSchedule': copyTemplateSchedule,
    'templateView': templateView,
    'rulesViolation': rulesViolation,
    'DatePicker': DatePicker,
    'createEmployeeModal': createEmployeeModal,
    'jobRolesFilter': jobRolesFilter,
    'editShift': editShift,
    'addShift': addShift,
    ClipLoader
  },
  data() {
    return {
      week        : 1,
      size        : '15px',
      sizeMain        : '35px',
      spinnerColor: '#00779C',
      loadingSpin : false,
      loadingSpinMain : false,
      currencySymbol: (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.symbol : 'Rs',
      filterActiveCus: false,
      isScheduleName: true,
      schedule_name: '',
      byWeekly: 1,
      selected: 1,
      isPageOverlayer: true,
      isTemplateView: false,
      isScheduleView: true,
      isPublished: true,
      previousSchedule: [],
      company_id: this.$store.getters.getSelectedCompany.id,
      isCopy: false,
      isPaste: false,
      isCopyByDate: false,
      isPasteByDate: false,
      isModalVisible: false,
      currentDate: moment(new Date()).format('YYYY-MM-DD'),
      startWeek: moment().weekday(1).format('YYYY-MM-DD'),
      endWeek: moment().weekday(7).format('YYYY-MM-DD'),
      // selectedDate: moment().weekday(1).format('YYYY-MM-DD') + '  ' + moment().weekday(7).format('YYYY-MM-DD'),
      selectedDate: [moment().weekday(1).format('YYYY-MM-DD'), moment().weekday(7).format('YYYY-MM-DD')],
      listProducts: '',
      date: new Date(),
      otherdate: new Date(),
      showCalendar: false,
      showCalendar1: false,
      roster_schedule_id: this.$route.params.id,
      schedule: [],
      weeksDates: [],
      weeksDatesByWeek: [],
      newarray: [],
      jobTypes: [],
      jobTypesEmployees: [],
      copySchedulesByDateArray: [],
      schedule_ids: [],
      scheduleForm: {
        date: '',
        start_time: '',
        end_time: '',
        break_time: '',
        job_role_id: '',
        employee_id: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        comment: '',
      },
      selectedShift: 0,
      selectedShiftForViolationEmpId: 0,
      selectedShiftForViolationDate: 0,
      shiftNeedAssignment: 0,
      hoursAssigned: 0,
      minutesAssigned: 0,
      availableShiftHours: 0,
      availableShiftMinutes: 0,
      totalHoursPerEmp: 0,
      totalMinutesPerEmp: 0,
      totalHoursPerEmployeeList: [],
      employeeRuleViolation: [],
      newDateNext: '',
      totalCostByDate: [],
      totalCost: [],
      employeeShiftHours: [],
      rulesViolationData:[],
      pasteSchedulesByDateData:[],
      copyByDate:'',
      isCopyPasteByDate:false,
      editShiftEmployee:[],
      rulesViolationThisPeriod:[],
      isPublishBtnDisable: true,
      isReferBY: (this.$store.getters.getUser.refer_by !='') ? true: false,
      isCompanyMembership: true
    }
  },

  created() {
     this.getCompany();
     this.getRulesViolation();
    this.sepratedate();
    this.getJobType();
    this.getPreviousSchedules();
    this.main();
    let that=this;
    document.addEventListener('keydown', function (evt) {
      if (evt.keyCode === 27) {
        that.isCopy=false;
          that.isPaste=false;
          that.isCopyByDate=false;
          that.isPasteByDate=false;
          that.isModalVisible=false;
      }
    });
  },

  methods: {
    refreshViolation(){
      this.filterActiveCus=false
      this.main();
    },
    hideCopyPasteByDateModalBtn(){
      this.isCopyPasteByDate=false;
    },
    getRulesViolation(){
      let params = {
        company_id: this.company_id,
      };
      this.$axios.get(this.$GeneralRulesViolation, { params: params, headers: this.getAuthHeader(),}).then(res => {
        if (res.data.status == 200) {
          if(res.data.result.rules_violation){
            this.rulesViolationData=  res.data.result.rules_violation
          }
        }
      });
    },
    highlightEmployee(shiftId,date){
      if( shiftId !=''){
        this.filterActiveCus=true
      }
      this.selectedShift='highlightShift_'+shiftId+'-'+date
    },
    highlightEmployeeShift(shiftId,date){

      this.$axios.get(this.$Schedule+'/'+shiftId+'/edit', {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status == 200) {
          $("#cardModal").modal("show");
          this.editShiftEmployee = res.data.result;
          this.editShiftEmployee.start_time = moment(date +' '+this.editShiftEmployee.start_time).format('HH:mm');
          this.editShiftEmployee.end_time = moment(date +' '+this.editShiftEmployee.end_time).format('HH:mm');
        }
      });
    },
   /* refreshJobRoles(){
      this.$root.$emit('refreshJobRoles');
    },
*/
    getCompany() {
      this.id = this.$store.getters.getSelectedCompany.id;
      this.$axios.get(this.$GetCompany.replace(":id", this.id), {
        headers: this.getAuthHeader(),
      }).then((response) => {
        if( response.data.result.company.membership==='' || response.data.result.company.membership===null){
          this.isCompanyMembership=false;
        }

      })
    },
    showEmpCreateModal() {
      if(this.isCompanyMembership===true || this.isReferBY===true || this.$store.getters.getSelectedCompany.partner_customer_no !=''){
        let element = this.$refs.modal.$el
        $(element).modal('show')
        this.$root.$emit("refreshJobRoles");
      }else{
        new Swal({
          title: "Info",
          icon: "warning",
          text: "Please upgrade your plan",
          type: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!"
        }).then((result) => {
          if (result.value) {
            this.$router.push('/upgrade-plan');
          }})
      }
    },

    isScheduleNameFun() {
      this.isScheduleName = true;
    },

   calculateHoursM( startTime, endTime,date) {
      return this.calculateHourMinutes( startTime, endTime,date);
    },

    hourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime,date) {
     return this.getHourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime,date);
    },
    //-----------------next button click -----------
    nextBtnClickFun() {
      this.isPageOverlayer = false;
      localStorage.setItem('isPageOverlayer', false);
    },

    //rules violation submit
    submitFormRules(res) {
      this.main();
    },

    filterFunction(value) {
      if(value == 0 || value==''){
        this.filterActiveCus=false;
      }else {
        this.filterActiveCus=true;
      }
      this.selectedShift =value;
    },

    scheduleBtnFun() {
      this.shiftNeedAssignment = 0,
        this.selected = 1;
      this.isTemplateView = false;
      this.isScheduleView = true;
      this.main();
    },

    templateBtnFun() {
      this.isTemplateView = true;
      this.isScheduleView = false;
      this.selected = 2;
    },
    //-----------------publish function -------------\
    publishScheduleFunction() {
      axios.post(this.$SchedulePublish,
        {
          start_date: this.startWeek,
          end_date: this.endWeek,
          name: this.schedule_name,
          roster_schedule_id: this.roster_schedule_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            $('#publishModel').modal('hide');
            this.$router.push('/dashboard');
          }
        });
    },
    scheduleNameSaveBtnClick(id){

      axios.post(this.$UpdateScheduleName,
        {
          id: id,
          name: this.schedule_name,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success("Updated");
          }
          this.scheduleNameShow=false;
          //Perform Success Action
        });
    },
    getPreviousSchedules() {
      let params = {
        company_id: this.company_id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };

      this.$axios.get(this.$getPreviousSchedules, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status == 200) {
          this.previousSchedule = res.data.result;
        }
      });
    },

// remove all function
    removeAllShiftFunction() {

      new Swal({
        title: "Remove all?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Remove all!"
      }).then((result) => {
        if (result.value) {
          axios.post(this.$DeleteSchedulesByRosterScheduleId, {roster_schedule_id: this.roster_schedule_id}
            , {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.status == 200) {
                this.main();
                this.totalHoursPerEmployeeList = [];
                this.hoursAssigned = 0;
                this.minutesAssigned = 0;
                this.totalHoursPerEmp = 0;
                this.totalMinutesPerEmp = 0;
              }
            });
        }})
    },
    // paste function
    pastScheduleFunction(date) {
      //this.isCopy = false;

      this.loadingSpinMain=true;
      this.scheduleForm.date = date;
      axios.post(this.$Schedules, this.scheduleForm
        , {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
          //  this.isCopy = false;
            this.loadingSpinMain=false;
            this.main();
          }
        });
    },
// copy code function
    singleCopyTestingCode(formData) {
      this.isCopy = true;
      this.scheduleForm=formData;
    },
    //----------------- previous schedule
    copyPreviousScheduleShifts(selected) {

      if(selected !=0){

        axios.post(this.$CopyPreviousScheduleAllShifts,
          {
            start_date: moment(this.startWeek).format('YYYY-MM-DD'),
            end_date: moment(this.endWeek).format('YYYY-MM-DD'),
            roster_schedule_id_selected: selected,
            roster_schedule_id: this.roster_schedule_id,
            company_id: this.company_id,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status === 200) {
              this.roster_schedule_id = res.data.result.id;
              this.main();
            }
          });
        }
    },
    // all schedules of date
    copySchedulesByDateFunction(date) {
      this.isCopyByDate = true;
      this.isPasteByDate = true;
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        date: moment(date).format('YYYY-MM-DD'),
      };
      this.$axios.get(this.$Schedule + '/by-date', {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.schedule = response.data.result;
        this.copySchedulesByDateArray = [];
        this.schedule.forEach(sc => {
          this.copySchedulesByDateArray.push(sc);
        });
      });
    },// all schedules of date
    deleteSchedulesByDateFunction(date) {
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        date: moment(date).format('YYYY-MM-DD'),
      };
      new Swal({
        title: "Delete Shifts by date?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.get(this.$DeleteScheduleByDate, {
            params: params,
            headers: this.getAuthHeader(),
          }).then(response => {
            if (response.data.status == 200) {
              this.main();
            }
          });
        }
      });
    },

    pasteSchedulesByDateFunction(date) {
      this.loadingSpinMain = true;
        this.scheduleForm.date = date;
        axios.post(this.$pasteSchedulesByDate,{data:this.copySchedulesByDateArray,date:date}
          , {headers: this.getAuthHeader()})
          .then((res) => {
            this.loadingSpinMain = false;
            if (res.data.status == 200) {
              if(res.data.result.length>0){
                this.isCopyPasteByDate = true;
                this.copyByDate = date;
                this.pasteSchedulesByDateData = (res.data.result)?res.data.result:'';
              }
              this.main();
            }
          });

    },

    addShiftBtn() {
      // alert(this.scheduleForm.employee_id);
      this.scheduleForm.date = "";
      this.scheduleForm.start_time = '';
      this.scheduleForm.end_time = '';
      this.scheduleForm.break_time = '';
      this.scheduleForm.job_role_id = '';
      this.scheduleForm.employee_id = '';
      this.scheduleForm.company_id = '';
      this.scheduleForm.comment = '';
      this.isModalVisible = true;
    },

    deleteSchedule(id) {
      this.main();
    },

    updateSchedule(response) {
    this.main();
    },

    selection(date) {
      if( date[0]){
        this.weekStartDate = date[0];
        this.weekEndDate = date[1];
        this.startWeek = date[0];
        this.endWeek = date[1];
        this.calculateWeeksDays(this.startWeek);
        this.showCalendar = false;
        this.getSchedulesByDateChnage();
        this.getPreviousSchedules();
      }
    },
    calculateWeeksDays(date) {
      var days = moment(this.endWeek).diff(moment(this.startWeek), 'days');
      var difWeek = moment(this.endWeek).diff(moment(this.startWeek), 'week');
      // let weekDd=moment(this.startWeek ).weekday(1).format('YYYY-MM-DD');
      let weekDd=moment(this.startWeek ).isoWeekday(1).format('YYYY-MM-DD');
      this.byWeekly = difWeek + 1;
      this.newDateNext = weekDd;
      for (let i = 1; i <= difWeek + 1; i++) {
        let curr = new Date(this.newDateNext);
        var newDate = moment(curr).add(-1, 'd').format('YYYY-MM-DD');
        newDate = moment(newDate);
        this.weeksDatesByWeek[i] = Array(7).fill().map(
          () => newDate.add(1,'d').format('YYYY-MM-DD')
        );
        this.newDateNext = moment(newDate).add(1, 'd');
        this.otherdate = moment(curr).add(6, 'd').format('YYYY-MM-DD');
        this.showCalendar = false;
      }
      this.getByWeekly(difWeek + 1);

    },

    getByWeekly(length) {
      this.byWeekly = length;
    },

    getJobType() {
      axios
        .get(this.$GetJobRulesType, {
          headers: this.getAuthHeader(),
          params: {
            company_id: this.company_id,
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.allJobTypes = res.data.result;
            this.jobTypes = this.allJobTypes;
          }
        });
    },

    getEmployeeByJobRoleId(id) {
      axios.get(this.$GetEmployeesByJobRolesType, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          company_id: this.company_id,
          date: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.jobTypesEmployees = res.data.result;
          }
        });
    },

    shiftSaveFunc(value) {
      this.isModalVisible = false;
      this.isModalVisible = false;
      this.roster_schedule_id=value;
     // this.$router.push('/schedule/'+this.roster_schedule_id);
     this.main()
    },

    addAnotherShiftFun(value) {
      this.isModalVisible = true;
      this.roster_schedule_id=value;
      this.main()
    },
    sepratedate() {
      this.date = new Date(this.date).toISOString().slice(0, 10);
      //  this.otherdate = new Date(this.otherdate).toISOString().slice(0, 10);
    },

    main() {
      this.loadingSpinMain = true;
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };
      if (this.$route.params.id == undefined) {
        this.calculateWeeksDays(this.startWeek);
      }
      this.$axios.get(this.$Schedule, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.hoursAssigned=0;
        this.minutesAssigned=0;
        this.totalHoursPerEmp= 0;
          this.totalMinutesPerEmp= 0;
        this.loadingSpinMain = false;
        this.employeeRuleViolation = [];
        if (response.status == 200) {
          if (response.data.result) {
            this.isPublishBtnDisable=false;
          this.schedule_name = (response.data.result) ? response.data.result.name : '';
          this.weekStartDate = response.data.result.start_date;
          this.weekEndDate = response.data.result.end_date;
          this.startWeek = response.data.result.start_date;
          this.endWeek = response.data.result.end_date;
          this.selectedDate = [moment(this.weekStartDate).format('YYYY-MM-DD'), moment(this.weekEndDate).format('YYYY-MM-DD')];
          this.getPreviousSchedules();
          this.calculateWeeksDays(this.weekStartDate);
          this.getTotalHoursPerEmployees();

          this.employeeShiftHours = (response.data.result.employeeShiftHours)?response.data.result.employeeShiftHours:'';
          this.schedule = response.data.result.schedules;
          var difWeek = moment(response.data.result.end_date).diff(moment(response.data.result.start_date), 'week');
          this.byWeekly = difWeek + 1;
          this.getByWeekly(difWeek + 1);
          var totalCost = 0;
          for (let week = 1; week <= difWeek + 1; week++) {
            this.totalCostByDate[week] = [];
            this.weeksDatesByWeek[week].forEach(wd => {
              var employeeCost = 0;
              // this.weeksDatesByWeek[week].push(wd);
              this.newarray[week + wd] = [];
              this.schedule.forEach((sc, key) => {
                if (wd == sc.date) {
                  if (sc.mark_deleted == 0) {
                    var hoursMinutes = this.calculateHoursM(sc.start_time, sc.end_time, sc.date);
                    var duration = moment.duration(hoursMinutes);
                    var hours = parseInt(duration.asHours());
                    var minutes = parseInt(duration.asMinutes()) - hours * 60;
                    if (sc.employee == null) {
                      this.shiftNeedAssignment = this.shiftNeedAssignment + 1;
                      this.availableShiftHours = this.availableShiftHours + hours;
                      this.availableShiftMinutes = this.availableShiftMinutes + minutes;
                    } else {
                      this.hoursAssigned = this.hoursAssigned + hours;
                      this.minutesAssigned = this.minutesAssigned + minutes;
                    }
                    this.totalHoursPerEmp = this.totalHoursPerEmp + hours;
                    this.totalMinutesPerEmp = this.totalMinutesPerEmp + minutes;
                    if (this.rulesViolationData.length > 0) {
                      // this.checkRuleViolation(response.data.result.id, sc.employee_id, sc.date); rulesViolationThisPeriod
                      //this.checkRuleViolation(response.data.result.id, sc.employee_id, sc.date);
                      const existEmployee = this.rulesViolationThisPeriod.findIndex(el => el === sc.employee_id );
                      if(existEmployee<0){
                        this.rulesViolationThisPeriod.push(sc.employee_id);
                      }
                    }
                    this.schedule_ids.push(sc.id);
                    //------------- calculate total date cost-------------------
                    if (sc.employee) {
                      if(sc.employee.employment_type =='full-time')
                      {
                        employeeCost = employeeCost + this.hourlyPriceCalculate(sc.emp_hourly_rate, sc.start_time, sc.end_time, sc.employee.name, 0, sc.date);
                      }else{
                        employeeCost = employeeCost + this.hourlyPriceCalculate(sc.employee.hourly_rate, sc.start_time, sc.end_time, sc.employee.name, 0, sc.date);
                      }
                    }
                    const maxWorkdaysInRow = this.newarray[week + wd].findIndex(el => el.start_time == sc.start_time & el.end_time == sc.end_time);
                    if (maxWorkdaysInRow < 0) {
                      this.newarray[week + wd].push(sc);
                    }
                  }
                }
              });

              totalCost = totalCost + employeeCost;
              this.totalCostByDate[week].push(employeeCost);
            });
          }
          this.totalCost = totalCost;
          this.checkRuleViolation();
        }
      }

      });

    },
    checkRuleViolation() {
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        employees: this.rulesViolationThisPeriod,
      };
      this.$axios.get(this.$GetRuleviolationByEmployeeId, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.employeeRuleViolation=response.data.result;

      });
    },

    getSchedulesByDateChnage() {
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.$route.params.id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };
      this.$axios.get(this.$Schedule, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        // if(response.data.result.published=='1'){
        //     this.isPublished=false;
        // }
        this.getPreviousSchedules();
        if(response.data.result){
          this.schedule = response.data.result.schedules;
          this.weeksDates.forEach(wd => {
            this.newarray[wd] = [];
            this.schedule.forEach(sc => {

              if (wd == sc.date) {
                this.schedule_ids.push(sc.id)
                this.newarray[wd].push(sc);

              }
            });
          });
        }

      });
    },

    getTotalHoursPerEmployees() {
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };
      this.$axios.get(this.$GetTotalHoursPerEmployee, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.totalHoursPerEmployeeList = response.data.result;
      });
    },

    currencyAmountFormat(value) {
      return this.currencyFormatter(value);
    }
  }
}
</script>

<style>


.btn {
  position: reltive;
}
.employee-benifits{
  max-height: 500px;
  overflow-y: auto !important;
}


.employee-benifits table th,
.employee-benifits table td{
  text-align: left !important;
}

.icoCopyByDate {
  font-size: 15px;
  margin-left: 10px;
  color: black;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: all .25s linear;
}

.btn:hover .icoCopyByDate {
  display: inline-block;
  vertical-align: middle;
  opacity: 1;
}

.inner-td-wrp {
  min-height: 200px;

}

.schedule-td:hover .inner-td-wrp .copy-days {
  display: block;
}


.arrow-r .arrow-icon::after {
  right: 41px !important;

}




.right-side .card {
  overflow: visible !important;
}

/*  .week-table{
    overflow-x: auto ;
    overflow-y: hidden;
  }
  .week-table table td{
    min-width: 165px;
  }*/

.job-roll {
  position: relative;
}

.job-roll .nav-selectdrop {
  position: static;
}

.job-roll .overlayer-input {
  visibility: visible;
  opacity: 1;
}

.overlayer-input {
  visibility: hidden;
  opacity: 0;
  display: flex;
  background: #fff;
  position: absolute;
  left: 0;
  top: 28px;

  right: 0;
  z-index: 1;
}

.overlayer-input input {
  width: 100%;
  margin-right: 10px;

}

.overlayer-input .btn-cancel, .btn-save {
  width: auto !important;
  margin: 0 5px;
}

.total-tag-sm {
  font-size: 10px;
  line-height: 14px;
  color: #989898;
  display: block;
  margin-bottom: 2px;
}

.week-table .mini-card .card-body h4 {

  line-height: 18px !important;
}

.shiftDropdownCus {
  /* background: #f6f6f6; */
  border-radius: 8px;

}


/*.col-red{
  color: ;
}*/

.total-hours-per-emp-cus {
  max-height: 360px;
  margin: 0 -20px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  background-clip: padding-box;
}
.matchShiftClassBg > .card-body{
  background: #00779c1f !important;
}
.cursor-pointer{
  cursor: pointer;
}
.spinnerCustom .v-spinner{
  /*display: block;*/
  position: absolute;
  margin: 0 auto;
  width: 100%;
  z-index: 1111111;
  top: 50%;
}
.week-table thead th {
  padding: 12px 1px 0px 1px !important;
}
.btn-hold{
  position: relative;
}
.btn-hold .ico-delete{
  position: absolute;
  left: -8px ;
  width: 13px;
}
.icoCopyByDate{
  right: 2px !important;
}

.spinnerCustom{

  display: block;
}
.spinnerCustom .v-spinner{
  left: 0;
}
.table{
  min-height: 100px;
}
.violation-box .violation-ul{
  margin: 0;
  padding: 0;
  list-style: none;
}
.violation-box .violation-list .violation-ul li{
  position: relative;
  padding: 0 0 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;

}
.violation-box .violation-list .violation-list-top{
  margin-bottom: 6px;
}
.violation-box .violation-list .violation-ul li:last-child{
  margin-bottom: 0;
}
.violation-box .violation-ul li::before{
  position: absolute;
  content:"";
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background: #005a76;
  border-radius: 50%;
}
</style>
